import styled from 'styled-components'

export const StyledSpinner = styled.div`
  width: ${(p) => {
    return p.size
  }};
  height: ${(p) => {
    return p.size
  }};
  border-radius: 50%;

  :after {
    border-radius: 50%;
    width: ${(p) => {
    return p.size
  }};
    height: ${(p) => {
    return p.size
  }};
  }

  margin: 10px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: ${(p) => {
    return p.secondaryColor ? '3px solid #FFF' : '3px solid #0aa1f4'
  }};
  border-right: ${(p) => {
    return p.secondaryColor ? '3px solid rgba(255, 255, 255, 0.5)' : '3px solid rgba(32, 32, 32, 0.2)'
  }};
  border-bottom: ${(p) => {
    return p.secondaryColor ? '3px solid rgba(255, 255, 255, 0.5)' : '3px solid rgba(32, 32, 32, 0.2)'
  }};
  border-left: ${(p) => {
    return p.secondaryColor ? '3px solid rgba(255, 255, 255, 0.5)' : '3px solid rgba(32, 32, 32, 0.2)'
  }};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: rotateSpinner 1.1s infinite linear;
  animation: rotateSpinner 1.1s infinite linear;

  @-webkit-keyframes rotateSpinner {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotateSpinner {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`
